<div class="collections card">
    <card i18n-headerTitle headerTitle="Collections" [hasFooter]="true">
        <div card-body class="card-body">
            <no-data-box
                *ngIf="!(dataSource.data$ | async)"
                [titleText]="noDataTitle"
            ></no-data-box>
            <div class="row" *ngIf="dataSource.data$ | async">
                <div class="col">
                    <lsq-data-table-mobile
                        *ngIf="isSmBelow$ | async"
                        [dataSource]="dataSource"
                        [borderlessCards]="false"
                    >
                        <ng-template #mobileCardHeader let-row="row">
                            <div class="mtc-header-wrapper">
                                <div class="mtc-header-content-left">
                                    <div class="mtc-header-super-title">
                                        CHECK #{{ row.checkNumber }}
                                    </div>
                                    <div class="mtc-header-title">
                                        {{ row.debtorName }}
                                    </div>
                                    <div class="mtc-header-sub-title">
                                        {{ this._getDateFormat(row.paymentDate) }}
                                    </div>
                                </div>
                            </div>
                        </ng-template>

                        <ng-template #mobileCardColumns let-row="row">
                            <div class="card-item">
                                <div class="card-item-label">
                                    {{ paymentDateHeader }}
                                </div>
                                <div class="card-item-value">
                                    <a
                                        class="truncated-text"
                                        [popover]="row.paymentDate"
                                        [href]="this.getCollectionURL(row.paymentDate)"
                                    >
                                        {{ this._getDateFormat(row.paymentDate) }}
                                    </a>
                                </div>
                            </div>

                            <div class="card-item">
                                <div class="card-item-label">
                                    {{ debtorNameHeader }}
                                </div>
                                <div class="card-item-value">
                                    <a [href]="this.getCustomerCollections(row)">
                                        <lsq-smart-truncate
                                            [value]="row.debtorName"
                                        ></lsq-smart-truncate>
                                    </a>
                                </div>
                            </div>

                            <div class="card-item">
                                <div class="card-item-label">
                                    {{ checkNumberHeader }}
                                </div>
                                <div class="card-item-value">CHECK #{{ row.checkNumber }}</div>
                            </div>

                            <div class="card-item">
                                <div class="card-item-label">
                                    {{ checkInvoiceAmountHeader }}
                                </div>
                                <div class="card-item-value">
                                    {{ row.checkInvoiceAmount | currencyDash }}
                                </div>
                            </div>

                            <div class="card-item">
                                <div class="card-item-label">
                                    {{ checkPaymentAmountHeader }}
                                </div>
                                <div class="card-item-value">
                                    {{ row.checkPaymentAmount | currencyDash }}
                                </div>
                            </div>
                        </ng-template>
                    </lsq-data-table-mobile>
                    <lsq-data-table
                        *ngIf="!(isSmBelow$ | async)"
                        [hasHeader]="true"
                        [hasFooter]="false"
                        [hasSpinner]="false"
                        [layoutFixed]="true"
                        [dataSource]="dataSource"
                    >
                        <lsq-column
                            [column]="{
                                header: paymentDateHeader,
                                key: 'paymentDate',
                                sortable: false,
                                width: '20%'
                            }"
                        >
                            <ng-template [custom-cell] let-row="row">
                                <a
                                    class="truncated-text"
                                    [popover]="row.paymentDate"
                                    [href]="this.getCollectionURL(row.paymentDate)"
                                >
                                    {{ this._getDateFormat(row.paymentDate) }}
                                </a>
                            </ng-template>
                        </lsq-column>
                        <lsq-column
                            [column]="{
                                header: debtorNameHeader,
                                key: 'debtorName',
                                sortable: false,
                                width: '20%'
                            }"
                        >
                            <ng-template [custom-cell] let-row="row">
                                <a [href]="this.getCustomerCollections(row)">
                                    <lsq-smart-truncate
                                        [value]="row.debtorName"
                                    ></lsq-smart-truncate>
                                </a>
                            </ng-template>
                        </lsq-column>
                        <lsq-column
                            [column]="{
                                header: checkNumberHeader,
                                key: 'checkNumber',
                                sortable: false,
                                width: '30%'
                            }"
                        >
                            <ng-template [custom-cell] let-row="row">
                                <lsq-smart-truncate
                                    [value]="'CHECK #' + row.checkNumber"
                                    [popoverValue]="row.checkNumber"
                                >
                                </lsq-smart-truncate>
                            </ng-template>
                        </lsq-column>
                        <lsq-currency-column
                            [column]="{
                                header: checkInvoiceAmountHeader,
                                key: 'checkInvoiceAmount',
                                sortable: false
                            }"
                        >
                        </lsq-currency-column>
                        <lsq-currency-column
                            [column]="{
                                header: checkPaymentAmountHeader,
                                key: 'checkPaymentAmount',
                                sortable: false
                            }"
                        >
                        </lsq-currency-column>
                    </lsq-data-table>
                </div>
            </div>
        </div>
        <div card-footer>
            <div class="footer-container">
                <a class="footer-text" [routerLink]="'reports/collections'" i18n
                    >View All Collections</a
                >
            </div>
        </div>
    </card>
</div>
